import Component from '../abstracts/Component';
import { SmoothScroll } from '../utils/SmoothScroll';

export default class CustomPanel extends Component {

  get SELECTORS() {
    return {
      panel: '.js-custom-panel',
      trigger: '.js-panel-trigger'
    };
  }

  get CLASSES() {
    return {
      open: 'is-open'
    };
  }

  constructor() {
    super();

    this.panel = $(this.SELECTORS.panel);
    this.trigger = $(this.SELECTORS.trigger);
    this.Opened = false;
    this.y = 0;

    let timing = this.panel.data('animate-time');

    if(timing) {
      this.animateTime = this.panel.data('animate-time');
    } else {
      this.animateTime = 450;
    }

    this.trigger.on('click.panel', (e) => {
      let target = e.currentTarget.dataset.target;
      let trigger = e.currentTarget;
      if($(e.currentTarget).parents('.c-wall-container').length) {
        target = $(e.currentTarget).closest('.c-wall-container').find(this.SELECTORS.panel);
      }
      this.togglePanel(target,trigger);
    })
  }


  autoAnimate (elem, time){
    let curHeight = $(elem).height();
    let autoHeight = $(elem).css('height', 'auto').height();
    $(elem).height(curHeight);
    $(elem).stop().animate({ height: autoHeight }, time, function(){$(elem).css('height', 'auto') });
  }


  togglePanel(target, trigger) {
    if(this.Opened) {
      let openLabel = trigger.dataset.labelShow;
      $(trigger).text(openLabel);
      this.closePanel(target).then(res => {
        SmoothScroll(window, 0, this.y, 'smooth');
      })
    } else {
      let closeLabel = trigger.dataset.labelClose;
      $(trigger).text(closeLabel);
      this.openPanel(target)
      this.y = $(trigger).offset().top
    }
  }


  openPanel(target) {
    let animateTime = this.animateTime;
    $(target).addClass(this.CLASSES.open);
    this.autoAnimate(target, animateTime);
    this.Opened = true;
  }


  closePanel(target) {
    return new Promise((resolve, reject) => {
      try {
        let animateTime = this.animateTime;
        $(target).removeClass(this.CLASSES.open);
        $(target).stop().animate({ height: '0' }, animateTime );
        this.Opened = false;
        resolve(true)
      } catch(e) {
        log.e(e);
      }
    });
  }
}
